export default class NewDJCEModel {
    constructor(data = {}) {
        this.declaracion = {
            id: data.declaracion?.declaracion?.id
                ? parseInt(data.declaracion?.id)
                : 0,
            usuario: data.declaracion?.usuario
                ? parseInt(data.declaracion?.usuario)
                : 0,
            habilitada: data.declaracion?.habilitada
                ? parseInt(data.declaracion?.habilitada)
                : 0,
            fecha: data.declaracion?.fecha || null,
            fecha_Cierre: data.declaracion?.fecha_Cierre || null,
            serie: data.declaracion?.serie
                ? parseInt(data.declaracion?.serie)
                : 0,
            numero: data.declaracion?.numero
                ? parseInt(data.declaracion?.numero)
                : 0,
            timbre: data.declaracion?.timbre || false,
            viniedo: data.declaracion?.viniedo || '',
            telefono: data.declaracion?.telefono || '',
            titulares: data.declaracion?.titulares || '',
            titulares_Documento: data.declaracion?.titulares_Documento || '',
            razon_social: data.declaracion?.razon_social || '',
            doc_id_Viticultor: data.declaracion?.doc_id_Viticultor || '',
            doc_id_tipo_Viticultor: data.declaracion?.doc_id_tipo_Viticultor
                ? parseInt(data.declaracion?.doc_id_tipo_Viticultor)
                : 0,
            firma_Viticultor: data.declaracion?.firma_Viticultor || '',
            ubicacion_X: data.declaracion?.ubicacion_X
                ? parseInt(data.declaracion?.ubicacion_X)
                : 0,
            ubicacion_Y: data.declaracion?.ubicacion_Y
                ? parseInt(data.declaracion?.ubicacion_Y)
                : 0,
            departamento: data.declaracion?.departamento || '',
            total_Superficie: data.declaracion?.total_Superficie
                ? parseInt(data.declaracion?.total_Superficie)
                : 0,
            padrones: data.declaracion?.padrones || '',
            total_Kilos: data.declaracion?.total_Kilos
                ? parseInt(data.declaracion?.total_Kilos)
                : 0,
            djcp_Id: data.declaracion?.djcp_Id
                ? parseInt(data.declaracion?.djcp_Id)
                : 0,
            vista_Id_Funcionario: data.declaracion?.vista_Id_Funcionario
                ? parseInt(data.declaracion?.vista_Id_Funcionario)
                : 0,
        };
        this.djceUvas = data.djceUvas || [];
        this.djceGuias = data.djceGuias || [];
    }
}
